// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const xatu: PokeData = {
  "id": 178,
  "name": "xatu",
  "height": 15,
  "weight": 150,
  "base_experience": 165,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "leer",
    "peck",
    "psychic",
    "teleport",
    "night-shade",
    "confuse-ray",
    "future-sight",
    "wish",
    "miracle-eye",
    "tailwind",
    "psycho-shift",
    "lucky-chant",
    "me-first",
    "power-swap",
    "guard-swap",
    "air-slash",
    "ominous-wind",
    "stored-power"
  ],
  "moves": [
    "leer",
    "peck",
    "psychic",
    "night-shade",
    "confuse-ray",
    "future-sight",
    "tailwind",
    "air-slash",
    "aerial-ace",
    "prismatic-cage",
    "healing-wish",
    "psywave",
    "gust"
  ],
  "evolution_chain": {
    "id": 88,
    "item": null,
    "species": [
      {
        "name": "natu",
        "order": 206,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "xatu",
        "order": 207,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 177,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 148,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
